<template>
    <div>
        <v-data-table
            :headers="headerss"
            :items="table"
            :items-per-page="cant?cant:10"
            class="elevation-4"
            :loading="loadings?loadings:null"
            @click:row="selectItem"
            no-data-text="no hay datos"
            no-results-text="no data"
            loading-text="cargando datos ..."
        >
        </v-data-table> 
    </div>
</template>
<script>
export default {

  props:{

    table:'',
    headerss:'',
    loadings:'',
    type:'',
    cant:'',
    headerss2:'',

},

 
methods: {
  
  selectItem:function(value){
    this.$store.dispatch('selectTableAction', {'type':this.type ,'valor':value});
    this.$store.dispatch('MenuEquipo', true);
  }

},

  data () {
      return {
        
    }
  }
}
</script>